import React, { useState, forwardRef } from 'react'

//* Components
import Text from 'components/common/Text'
import Icon from 'components/common/Icon'

//* Style
import AccordionStyle from './style'

const Accordion = forwardRef(({ title, text, className, ...props }, ref) => {
    //! States
    const [isActive, setIsActive] = useState(false)

    return (
        <AccordionStyle ref={ref} className={`${className || ''} ${isActive ? 'active' : ''}`}>
            <div
                className={`accordion ${isActive ? 'active' : ''}`}
                onClick={() => {
                    setIsActive(!isActive)
                }}
            >
                <div className={`accordion-summary`}>
                    <div className='title-wrap'>
                        <Text className={'h3 font-soundscape-bold'} text={title} />
                        <Icon name={'arrow'} className={`accordion-arrow`} />
                    </div>
                    <div className={`collapse`}>
                        <div className='accordion-description-wrap'>
                            <Text className={`h5 accordion-description`} text={text} />
                        </div>
                    </div>
                </div>
            </div>
        </AccordionStyle>
    )
})

export default Accordion
